import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '@client';

export const qaAdminHistoricalDataApi = createApi({
  baseQuery: axiosBaseQuery(),
  reducerPath: 'qaAdminHistoricalData_api',
  endpoints: (build) => ({
    calculateHusbandryHistoricalDataFromPricelists: build.mutation<void, void>({
      query: () => ({
        url: `/secured/admin/husbandry-historical-data/calculate-pricelist-data`,
        method: 'POST',
        data: {}
      })
    }),
    calculateHusbandryHistoricalDataFromFdas: build.mutation<void, void>({
      query: () => ({
        url: `/secured/admin/husbandry-historical-data/calculate-fda-data`,
        method: 'POST',
        data: {}
      })
    })
  })
});

export type StateWithQaAdminHistoricalDataApi = {
  [qaAdminHistoricalDataApi.reducerPath]: ReturnType<
    typeof qaAdminHistoricalDataApi.reducer
  >;
};

export const {
  useCalculateHusbandryHistoricalDataFromPricelistsMutation,
  useCalculateHusbandryHistoricalDataFromFdasMutation
} = qaAdminHistoricalDataApi;
